module.exports = __webpack_public_path__ + "img/img5.799a4ec3.png";